/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APICategory } from './APICategory';
import {
    APICategoryFromJSON,
    APICategoryFromJSONTyped,
    APICategoryToJSON,
} from './APICategory';

/**
 * 
 * @export
 * @interface APIPaginatedCategoryList
 */
export interface APIPaginatedCategoryList {
    /**
     * 
     * @type {number}
     * @memberof APIPaginatedCategoryList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedCategoryList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedCategoryList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<APICategory>}
     * @memberof APIPaginatedCategoryList
     */
    results: Array<APICategory>;
}

/**
 * Check if a given object implements the APIPaginatedCategoryList interface.
 */
export function instanceOfAPIPaginatedCategoryList(value: object): value is APIPaginatedCategoryList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function APIPaginatedCategoryListFromJSON(json: any): APIPaginatedCategoryList {
    return APIPaginatedCategoryListFromJSONTyped(json, false);
}

export function APIPaginatedCategoryListFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPaginatedCategoryList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(APICategoryFromJSON)),
    };
}

export function APIPaginatedCategoryListToJSON(value?: APIPaginatedCategoryList | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(APICategoryToJSON)),
    };
}

